<template>
    <div class="recruitItem">
        <div class="recruitItem__container">
            <!--==== 顶部文字  ====-->
            <div class="recruitItem__topCon">
                <div class="recruitItem__topCon--logo">
                    <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png">
                </div>
                <div class="recruitItem__topCon--txt">
                    <p class="recruitItem__topCon--font1">皇家加勒比游轮船务（中国）有限公司</p>
                    <p class="recruitItem__topCon--font2">Great vacations begin with great employees</p>
                </div>
            </div>
            <!--==== 图片链接  ====-->
            <div class="recruitItem_picLists">
                <div class="item--body">
                    <p class="item--location">{{city.name}}</p>
                    <p class="item--info"></p>
                    <div class="item--pic">
                        <img :src="city.bannerImage">
                    </div>
                </div>
            </div>
            <!--==== 文字链接 hot  ====-->
            <div class="recruitItem_hotLists" style="padding-bottom: 30px" v-if="positions.length > 0">
                <div class="recruitItem__title">
                    <p>职位</p>
                </div>
                <div class="recruitItem_hotLists__items">

                    <div class="hotLists__item">
                        <div class="item--Topdisplay item--title">
                            <p>职位名称</p>
                        </div>
                        <div class="item--Topdisplay item--department">
                            <p>部门</p>
                        </div>
                        <div class="item--Topdisplay item--date">
                            <p>发布日期</p>
                        </div>
                        <div class="item--Topdisplay item--applyBtn">
                            <p>我要应聘</p>
                        </div>
                    </div>

                    <div class="hotLists__item" v-for="(job, i) in positions" :key="('job_'+job.id)"
                     :class="{ 'hotListActive': i%2==0}">
                        <a :href="('Detail?position='+job.id)" target="_blank">
                            <div class="item--display item--title">
                                <p>{{job.title}}</p>
                            </div>
                            <div class="item--display item--department">
                                <p>{{job.department}}</p>
                            </div>
                            <div class="item--display item--date">
                                <p>{{getPublishTime(job.launchDate)}}</p>
                            </div>
                            <div class="item--display item--applyBtn">
                                <div class="hotLists__applyBtn">
                                    <p>我要应聘</p>
                                </div>
                            </div>
                        </a>
                    </div>


                </div>
            </div>

            <div class="recruitItem_hotLists" style="padding-bottom: 30px" v-else>
                <div class="recruitItem__title" style="border: none">
                    <p>暂无开放职位</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "RecruitmentSearch",
    data () {
        return {
            city: {},
            positions: []
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage () {
            const cityName = this.$router.currentRoute.query.cityName
            if (!cityName || cityName.length == 0) {
                return this.goHome()
            }
            const { success, data } = await api.page.getRecruitmentSearch(cityName)
            if (!success || !data || !data.city) {
                return this.goHome()
            }
            this.city = data.city
            this.positions = data.positions || []
        },
        goHome () {
            return this.$router.push({
                name: "RecruitmentIndex"
            })
        },
        getPublishTime (time) {
            let publishTime = time + ''
            if (publishTime.length > 10) {
                publishTime = publishTime.substring(0, 10)
            }
            return publishTime.split('-').join('.')
        }
    }
}
</script>

<style lang="less" scoped>
.recruitItem a,.recruitItem a:hover,.recruitItem a:link
{
    text-decoration:none;
}

.recruitItem{
    width:100%;
	background:#f0f5ff;
	padding-top: 80px;
}
.recruitItem__container {
    width:100%;
    min-width:1000px;
    background:#f0f5ff;
    padding:0px 15px;
}

/*topbanner*/
.recruitItem__topCon{
	width: 100%;
	text-align: center;
}
.recruitItem__topCon--logo{
	width:43px;
	height:47px;
	margin: 0 auto;
}
.recruitItem__topCon--logo > img{
	height:100%;
}
.recruitItem__topCon--txt{
	margin-top: 26px;
}
.recruitItem__topCon--txt p{
	color: #031356;
    font-weight:400;
    margin:0px;
}
.recruitItem__topCon--font1 {
    font-size: 22px;
}
.recruitItem__topCon--font2{
    font-size: 30px;
}


/*图片链接*/
.recruitItem_picLists{
	width:100%;
	margin-top: 46px;
}
.item--body{
	/*width:60.0833%;*/
    width:1000px;
	margin:0 auto;
	padding:20px 14px;
	background: #fff;
}
.item--location{
	color: #0070b7;
    font-weight:400;
}
.item--info{
	color: #626262;
    font-weight:400;
}
.item--pic{
	width: 100%;
}
.item--pic img{
	width: 100%;
}


/*文字链接 hot*/
.recruitItem_hotLists{
	width:100%;
	margin-top:96px;
    padding-bottom: 30px;
}
.recruitItem__title{
	/*width:60.0833%;*/
    width:1000px;
	margin:0 auto;
	padding-left:1%;
	border-bottom: 1px solid #031356;
}
.recruitItem__title p{
	font-size: 18px;
	font-weight: bold;
	color: #031356;
}
.recruitItem_hotLists__items{
	width: 100%;
}
.hotLists__item{
	/*width:60.0833%;*/
    width:1000px;
	margin:0px auto;
	margin-top: 10px;
	overflow: hidden;
	padding:10px 0px 10px 1%;
}
.item--Topdisplay,.item--display{
    margin-right: 8%;
    display: inline-block;
    text-align: left;
    font-weight:400;
}
.item--title{
	width:36%;
}
.item--department{
	width:18%;
}
.item--date{
	width:10%;
	text-align: center;
}
.item--applyBtn{
	width:84px;
	text-align: center;
	cursor: pointer;
    margin-right:0px;
}
.item--Topdisplay p{
	font-size: 18px;
	font-weight: bold;
	color: #031356;
}
.item--display{
	font-size: 18px;
	color: #444;
    word-break:break-word;
    vertical-align:top;
}
.hotLists__applyBtn{
    width:84px;
	height:34px;
	line-height: 32px;
	border:1px dotted #8f8f99;
	border-radius: 8px;
    margin:0 auto;
}
.hotLists__applyBtn p{
	color:#0070b7;
	margin:0;
}

.hotListActive{
	background: #eeefff;
}


</style>
